<template>
    <div v-if="job.id_gestor == user.id_funcionario && (job.status == 'Com Gestor' || job.status == 'Categorizado') && perfis.indexOf(user.grupo)"
        class="categorize column">
        <Button layout="gold" @click="start"><i class="fa fa-filter" />
            Categorizar</Button>
        <Modal :modal="modal">
            <div class="row wrap">
                <div class="grid-2 padding column">
                    <label>Cliente</label>
                    {{ job.nome_cliente }}
                </div>
                <div class="grid-2 padding column">
                    <label>Agendamento</label>
                    {{ job.dh_agendamento_cliente | date }}
                </div>
                <ClienteCliente :css="'grid-2 grid-12-s column padding'" :cliente="job.id_cliente"
                    :atual="form.id_cliente_cliente" @value="vincularClienteCliente" />
                <AgregateClient :key="'agregado' + chaveAgregado" :css="'grid-2 grid-12-s column padding'"
                    :client="job.id_cliente" @value="vincularAgregado" />
                <small v-if="form.id_cliente_cliente || form.id_agregado_cliente" class="grid-12 exclusao">
                    Cliente do cliente e agregado do cliente não se combinam: escolher um limpa o outro.
                </small>

                <div class="column grid-3 grid-12-s padding">
                    <label>Orientação</label>
                    <SelectFilter v-if="guidelines.length" :list="guidelines" :readonly="false"
                        @value="(item) => (form.id_orientacao = item.id)" :name="['nome', 'nome_cliente']"
                        :text="form.nome_orientacao" />
                </div>
                <div class="grid-2 grid-12-s column padding">
                    <label>Tipo atendimento</label>
                    <select class="input" v-model="form.tipo" @change="form.forma_atendimento = ''; showDiary = false">
                        <option value>Selecione</option>
                        <option value="atendimento">Avulso</option>
                        <option value="alocacao">Alocação</option>
                    </select>
                </div>
                <div class="column grid-2 grid-12-s padding">
                    <label>Forma atendimento</label>
                    <select v-model="form.forma_atendimento" required>
                        <option value>Selecione</option>
                        <option value="presencial">Presencial</option>
                        <option value="remoto">Remoto</option>
                    </select>
                </div>
                <div class="column grid-2-g grid-3-m grid-12-s" v-if="showFolgaObrigatoria">
                    <label>Intervalo de Almoço <i>(HH:MM)</i></label>
                    <input v-model="form.folga_obrigatoria" v-mask="'##:##'" placeholder="Intervalo de Almoço (HH:MM)"
                        required />
                </div>
                <div class="grid-2 grid-12-s column padding">
                    <label>Divulgação</label>
                    <select class="input" v-model="form.divulga">
                        <option :value="false">Não</option>
                        <option :value="true">Sim</option>
                    </select>
                </div>
                <div class="grid-3 grid-12-s column padding">
                    <label>Fora Horário Comercial</label>
                    <select class="input" v-model="form.valor_diferenciado">
                        <option :value="false">Não</option>
                        <option :value="true">Sim</option>
                    </select>
                </div>
                <ServiceType v-if="form.forma_atendimento && form.tipo" :forma_atendimento="form.forma_atendimento"
                    :id_base_custo="job.id_base_custo" :tipo="form.tipo" :text="job.tipo_servico"
                    :css="'grid-4 grid-12-s column padding'" @value="(item) => updateServiceType(item)" />
                <Diary v-if="showDiary" :form="form" :css="'grid-12'" :schedule="schedule" @update="dt" />
            </div>
            <div v-if="mapa.length" class="mapa">
                <h3 class="text-center-s">Campos adicionais</h3>
                <div class="row wp col-s">
                    <Campo v-for="m of mapa_registro" :key="m.nome" :f="m" :up="(v) => campos[m.nome] = v"
                        :v="campos[m.nome]" />
                </div>
            </div>
            <div class="row controls justify-end" v-if="form.id_tipo_servico">
                <Button layout="gold" @click="categorize" :loader="load"><i class="fa fa-filter" v-if="!load" />
                    Categorizar</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import Campo from "@/components/Campo";
import AgregateClient from "@/components/select/AgregateClient.vue";
import ClienteCliente from "@/components/select/ClienteCliente.vue";
import ServiceType from "@/components/select/ServiceType.vue";
import Diary from "@/components/Diary.vue";
import SelectFilter from "@/components/select/SelectFilter";
export default {
    name: "Categorize",
    props: { show: Boolean, job: Object },
    components: { Button, Modal, AgregateClient, ClienteCliente, ServiceType, Diary, SelectFilter, Campo },
    data() {
        return {
            dias_cancelados_agenda: [],
            schedule: [],
            form: {
                forma_atendimento: '',
                divulga: false,
                nome_orientacao: '',
                cancelados_cliente: '',
                dias_uteis_alocacao: 0,
                feriados: '',
                folga_obrigatoria: '00:00',
                id_agregado_cliente: null,
                // O detalhe do job já traz o id; vale mesmo sem categorização (job criado por integração).
                id_cliente_cliente: this.job.id_cliente_cliente || null,
                id_orientacao: '',
                id_tipo_servico: '',
                tipo: '',
                trabalha_domingo: false,
                trabalha_sabado: false,
                dh_agendamento_cliente: this.job.dh_agendamento_cliente,
                valor_diferenciado: false
            },
            sabado: 0,
            domingo: 0,
            perfis: ['Gestor de Demanda', 'Gestor de Registro', 'Gestor de Device', 'Gestor de Infra', 'Gestor de Associação', 'TI', 'Gestor de Operação', 'Diretor de Operação', 'Financeiro'],
            showDiary: false,
            showFolgaObrigatoria: false,
            tipo_atendimento: [],
            chaveAgregado: 0, // remonta o seletor de agregado ao limpá-lo, pois ele não tem como ser limpo por fora
            guidelines: [],
            load: false,
            modal: {
                title: 'Categorização Job ' + this.job.id,
                show: this.show,
            },
            money: {
                decimal: ",",
                thousands: ".",
                precision: 2,
                masked: false,
            },
            mapa: [],
            campos: {}
        }

    },
    computed: {
        ...mapGetters("user", ["user"]),
        mapa_registro() {
            return this.mapa.filter(m => m.etapa == "registro")
        },
    },
    beforeMount() {
        if (this.job.id_tipo_servico) {
            this.form.forma_atendimento = this.job.forma_atendimento
            this.form.id_tipo_servico = this.job.id_tipo_servico;
            this.form.nome_orientacao = this.job.nome_orientacao;
            this.form.id_orientacao = this.job.id_orientacao;
            this.form.dias_uteis_alocacao = this.job.dias_uteis_alocacao
            this.form.dh_agendamento_cliente = this.job.dh_agendamento_cliente
            this.form.valor_diferenciado = this.job.valor_diferenciado
            this.form.tipo = this.job.tipo;
            this.form.trabalha_sabado = this.job.trabalha_sabado
            this.form.trabalha_domingo = this.job.trabalha_domingo
            if (this.job.cancelados_cliente) this.form.cancelados_cliente = this.job.cancelados_cliente
            if (this.form.tipo == 'alocacao') this.loadAgenda()
            if (this.job.mapa_campos) {
                this.mapa = this.job.mapa_campos
                this.mapa.map(f => f.etapa == "registro" ? this.campos[f.nome] = this.job[f.nome] : false)
            }
        }
        this.GUIDELINES_LIST({ status: "ativo", id_cliente: this.job.id_cliente}).then(({ data }) => { if (data) this.guidelines = data || []; });
    },
    methods: {
        ...mapActions("client", ["DIARY_LIST"]),
        ...mapActions("admin", ["GUIDELINES_LIST", "CATEGORIZE"]),
        start() {
            this.modal = { ...this.modal, show: true }
            this.$forceUpdate()
        },
        // O backend recusa cliente do cliente e agregado do cliente juntos: escolher um limpa o outro.
        vincularClienteCliente(id) {
            this.form.id_cliente_cliente = id
            if (id && this.form.id_agregado_cliente) {
                this.form.id_agregado_cliente = null
                this.chaveAgregado++
            }
        },
        vincularAgregado(item) {
            this.form.id_agregado_cliente = item.id
            if (item.id) this.form.id_cliente_cliente = null
        },
        async loadAgenda() {

            /*   if (this.job.status == "Com Gestor") */
            await this.DIARY_LIST(`${this.form.id_tipo_servico}/${this.job.dh_agendamento_cliente.slice(0, 16).replace("T", "%20")}`).then(({ data }) => {

                let cancelados = []

                data.map((d, i) => {
                    let day = new Date(d.dt_atendimento).getDay()

                    if (this.job.cancelados_cliente.length) {
                        cancelados = this.form.cancelados_cliente.split(';')
                        cancelados.map((d, i) => cancelados[i] = d.split('/').reverse().join('-'))
                    }

                    if ((day == 5 && this.job.trabalha_sabado) || (day == 6 && this.job.trabalha_domingo)) data[i].status = 'agendado'
                    if (cancelados.includes(d.dt_atendimento)) data[i].status = 'cancelado'
                })

                this.form.dias_uteis_alocacao = data.filter(d => d.status == 'agendado').length
                this.schedule = [...data]
            });

            this.showDiary = true

        },
        async categorize() {
            this.load = true

            if (this.sabado) this.form.trabalha_sabado = true
            if (this.domingo) this.form.trabalha_domingo = true

            if (this.form.tipo == 'alocacao' && this.dias_cancelados_agenda.length)
                this.form.cancelados_cliente = this.dias_cancelados_agenda.join(';')
            
            let form = {
                id: this.job.id,
                feriados: this.job.feriados,
                cancelados_cliente: this.form.cancelados_cliente,
                dias_uteis_alocacao: this.form.tipo == 'alocacao' ? this.form.dias_uteis_alocacao : 0,
                folga_obrigatoria: this.form.folga_obrigatoria + ':00',
                divulga: this.form.divulga,
                forma_atendimento: this.form.forma_atendimento,
                id_agregado_cliente: this.form.id_agregado_cliente,
                id_cliente_cliente: this.form.id_cliente_cliente,
                id_orientacao: this.form.id_orientacao,
                id_tipo_servico: this.form.id_tipo_servico,
                tipo: this.form.tipo,
                valor_diferenciado: this.form.valor_diferenciado,
                trabalha_sabado: this.form.trabalha_sabado,
                trabalha_domingo: this.form.trabalha_domingo,
                ...this.campos
            }

            let { status } = await this.CATEGORIZE(form)
            if (status == 200) {
                this.$emit("update");
                this.modal.show = false
            }
            this.load = false
        },
        updateServiceType(item) {
            this.showDiary = false
            this.showFolgaObrigatoria = item.requer_folga_obrigatoria || false;
            this.form.id_tipo_servico = item.id;
            this.form.tipo = item.tipo;
            this.showDiary = item.tipo == "alocacao" ? true : false;
            if (item.tipo == "alocacao") this.loadAgenda()

            if (item.mapa_campos) {
                this.mapa = item.mapa_campos
                this.campos = {}
                this.mapa.map(m => m.etapa == 'registro' ? this.campos[m.nome] = null : false)

            } else this.mapa = []
            this.$forceUpdate();
        },
        dt(i) {
            if (i > -1) {
                let day = new Date(this.schedule[i].dt_atendimento).getDay()
                if (day < 5 || (day == 5 && this.form.trabalha_sabado) || (day == 6 && this.form.trabalha_domingo)) {
                    this.dias_cancelados_agenda.filter(d => d != this.schedule[i].dt_atendimento)
                    this.schedule[i].status = this.schedule[i].status == 'agendado' ? 'cancelado' : 'agendado';
                    if (this.schedule[i].status == 'cancelado') this.dias_cancelados_agenda.push(this.schedule[i].dt_atendimento)
                }
            } else {
                this.schedule.map((d, x) => {
                    let day = new Date(this.schedule[x].dt_atendimento).getDay()
                    if (day == 5 || day == 6) this.dias_cancelados_agenda = this.dias_cancelados_agenda.filter(dd => dd != d.dt_atendimento)
                    if (day == 5) this.schedule[x].status = this.form.trabalha_sabado ? 'agendado' : 'feriado'
                    if (day == 6) this.schedule[x].status = this.form.trabalha_domingo ? 'agendado' : 'feriado'
                })
            }
            this.form.dias_uteis_alocacao = this.schedule.filter(d => d.status == 'agendado').length
        },

    }
};
</script>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.categorize
    .sfl
        margin-top: -65px
    .modal-box
        padding: 33px
        @media (min-width: $small)
            min-width: 700px
        .content
            padding: 40px
            color: $font-color
            font-size: 15px
            @media (max-width: $small)
                padding: 20px
            .padding
                padding-right: 12px
            .diary
                .row:first-child
                    margin-top: 50px          
        label
            @include label
            margin-top: 23px
    .controls
        margin-top: 60px
    .sfl
        min-height: 200px
    .mapa
        margin-top: 40px
        h3
            color: $purple
            @media (max-width: $small)
                padding-top: 20px
                font-size: 24px

</style>